import { useTranslation } from "react-i18next";

const TrainShipping = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className="font-semibold text-[32px] text-center pb-10 ">
            {t("shippingByTrains")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("railFreightInEurope")}
          </h2>
          <p className="my-4 text-lg">{t("railFreightInEuropeSig")}</p>

          <h3 className="text-mainBlue">{t("WhyRailFreight?")}</h3>
          <p className="mb-4">{t("lowerCosts")}</p>
          <h3 className="text-mainBlue">{t("highSpeedRoute")}</h3>
          <p className="mb-4">{t("highSpeedRailRoute")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/trainTransport1.jpg"
            alt="train transport1 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/trainTransport2.jpg"
            alt="train transport1 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/trainTransport3.jpg"
            alt="train transport1 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/trainTransport4.jpg"
            alt="train transport1 4"
          />
        </section>

        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("AdvantagesOfRoute")}
          </h2>
          <p>{t("FastAndSafeRailFreight")}</p>
          <div className="space-y-4">
            <h2 className="text-mainRed text-[20px] font-bold my-4">
              {t("stagesOFUnloading")}
            </h2>
            <div>
              <h3 className="text-mainBlue">{t("unloadingShips")}</h3>
              <p>{t("uponArrival")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("customClearance")}</h3>
              <p>{t("goodsAreInspected")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("temporaryStorage")}</h3>
              <p>{t("someGoodsTransferred")}</p>
              <span>{t("TransportingToRegions")}</span>
              <p>{t("trainsAreIdeal")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("challengesInGoodsDistribution")}</h3>
              <p>{t("infrastructureIssues")}</p>
            </div>
            <div className="space-y-2">
              <h3 className="text-mainBlue">{t("improveGoodsDistribution?")}</h3>
              <p>{t("enhancingInfrastructure")}</p>
              <p>{t("leveragingTechnology")}</p>
              <p>{t("increasingIntermodalTransport")}</p>
              <p>{t("simplifyingCustomsProcedures")}</p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default TrainShipping;
